/*
 * FulfillmentNoteDetailPage Messages
 *
 * This contains all the text for the FulfillmentNoteDetailPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.FulfillmentNoteDetailPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Chi tiết phiếu giao',
  },
});
